/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosportsStaggeredProductsListViewProps } from './hosports-staggered-products-list';

export default (props: IHosportsStaggeredProductsListViewProps) => {
  return (
    <div className='row'>
        <h2>{'Product List'}</h2>
    </div>
  );
};
